import { useState, useEffect } from "react";
import { fetchSecMasterItems } from "../../http/api";

export const useSecMasterData = (token, page, itemsPerPage, sortConfig = null, refreshKey = 0, filters = null) => {
  const [secMasterData, setSecMasterData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const payload = {
          page,
          size: itemsPerPage,
          ...(sortConfig?.columnToSort && {
            columnToSort: sortConfig.columnToSort,
            sortingDirection: sortConfig.sortingDirection,
          }),
          // Merge applied search filters (watchlist-shaped payload: type, minCoupon,
          // maxMaturity, minRatingSP, state, sector, callable, ...).
          ...(filters || {}),
        };

        const data = await fetchSecMasterItems(token, payload);
        setSecMasterData(data?.content ?? []);
        setTotalElements(data?.totalElements ?? 0);
        setLastUpdatedAt(data?.lastUpdatedAt ?? null);
      } catch (err) {
        console.error("Error fetching sec master data:", err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, page, itemsPerPage, sortConfig, refreshKey, filters]);

  return { secMasterData, totalElements, lastUpdatedAt, loading, error };
};
